import { useEffect } from "react";
import { useLogoutMutation } from "../../store/api";
import { CLIENT_ID, LOGOUT_REDIRECT_URI } from "../../constants/environment";

interface LogoutProps {
  idToken: string;
  refreshToken: string;
}

const Logout = ({ idToken, refreshToken }: LogoutProps): JSX.Element => {
  const [logout] = useLogoutMutation();
  useEffect(() => {
    logout({
      client_id: CLIENT_ID,
      id_token_hint: idToken,
      refresh_token: refreshToken,
      post_redirect_uri: LOGOUT_REDIRECT_URI,
    }).finally(() => {
      window.location.href = LOGOUT_REDIRECT_URI;
    });
  }, []);

  return <div />;
};
export default Logout;
